import React, { useEffect, useState } from "react";
import swal from "sweetalert";
import { URL } from "../../../utils/Constants";
import { axiosPost } from "../../../utils/AxiosApi";

export const useGeneralAssessmentSelectByYearAndClass = () => {
  const [assessments, setAssessments] = useState([]);
  const [assessmentsLoading, setAssessmentsLoading] = useState(false);

  const generalAssessmentSelectByYearAndClass = (params) => {
    setAssessmentsLoading(true);
    axiosPost(
      URL.generalAssessmentSelectByYearAndClass,
      params,
      (response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          const processedData = data?.map((item) => ({
            educationLevelDivisionId: item?.educationLevelDivisionId,
            label: item?.assessment?.assessmentName,
            value: item?.assessment?.id,
          }));
          setAssessments(processedData);
        }
        setAssessmentsLoading(false);
      },
      (error) => {
        setAssessmentsLoading(false);
      },
    );
  };

  return {
    assessments,
    assessmentsLoading,
    generalAssessmentSelectByYearAndClass,
  };
};

export const useIsGeneralAssessmentFinalized = () => {
  const [finalized, setFinalized] = useState([]);
  const [loading, setLoading] = useState(false);

  const getAssessmentFinalized = (params) => {
    axiosPost(URL.selectGeneralAssessmentIsFinalized, params, (response) => {
      if (response?.status === 200) {
        setFinalized(response?.data?.data);
      }
    });
  };

  const updateAssessmentFinalized = (params) => {
    setLoading(true);
    axiosPost(
      URL.studentGeneralAssessmentFinalize,
      params,
      (response) => {
        if (response?.status === 200) {
          swal(
            "Success",
            `Successfully ${params?.isFinalized ? "Finalized" : "Unfinalized"} assessment`,
          );

          const finalizedParams = {
            assessmentId: params?.assessmentId,
            classroomId: params?.classroomId,
            yearLevelId: params?.yearLevelId,
          };
          getAssessmentFinalized(finalizedParams);
        }
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        swal(
          "Oops",
          error?.response?.data?.message ||
            `Failed to ${params?.isFinalized ? "finalized" : "unfinalized"} assessment`,
        );
      },
    );
  };

  return {
    loading,
    finalized,
    getAssessmentFinalized,
    updateAssessmentFinalized,
  };
};

export const useGeneralRecordedAssessment = () => {
  const [recordedAssessment, setRecordedAssessment] = useState();
  const [recordedAssessmentLoading, setRecordedAssessmentLoading] = useState({
    read: false,
    insert: false,
  });

  const selectGeneralRecordedAssessment = (params) => {
    setRecordedAssessmentLoading((prev) => ({ ...prev, read: true }));
    axiosPost(
      URL.selectGeneralRecordedAssessment,
      params,
      (response) => {
        if (response.status === 200) {
          const data = response?.data?.data;
          setRecordedAssessment(data);
        }
        setRecordedAssessmentLoading((prev) => ({ ...prev, read: false }));
      },
      (error) => {
        setRecordedAssessmentLoading((prev) => ({ ...prev, read: false }));
      },
    );
  };

  const saveGeneralRecordedAssessment = (payload) => {
    setRecordedAssessmentLoading((prev) => ({ ...prev, insert: true }));
    return new Promise((resolve, reject) => {
      axiosPost(
        URL.studentGeneralAssessmentInsert,
        payload,
        (response) => {
          if (response.status === 200) {
            swal("Success", "Successfully saved general assesment records");
            resolve(response);
          } else {
            reject(response);
          }
          setRecordedAssessmentLoading((prev) => ({ ...prev, insert: false }));
        },
        (error) => {
          swal(
            "Oops",
            error?.response?.data?.message ||
              "Failed to save general assesment records",
          );
          setRecordedAssessmentLoading((prev) => ({ ...prev, insert: false }));
          reject(error);
        },
      );
    });
  };

  return {
    recordedAssessment,
    recordedAssessmentLoading,
    selectGeneralRecordedAssessment,
    saveGeneralRecordedAssessment,
  };
};

export const useStudentNameValuePair = () => {
  const [tagsValue, setTagsValue] = useState([]);

  const getStudentNameValuePair = (id) => {
    axiosPost(URL.studentNameValuePair, { id: id }, (response) => {
      if (response?.status === 200) {
        setTagsValue(response?.data?.data);
      }
    });
  };

  return { tagsValue, getStudentNameValuePair };
};

export const useCommentBank = () => {
  const [commentBank, setCommentBank] = useState([]);
  const [loading, setLoading] = useState({
    read: false,
    create: false,
    delete: false,
    update: false,
  });

  const getCommentBank = (payload) => {
    setLoading((prev) => ({ ...prev, read: true }));
    axiosPost(
      URL.getCommentBanks,
      { myTemplate: payload },
      (response) => {
        if (response?.status === 200) {
          setCommentBank(response?.data?.data);
        }
        setLoading((prev) => ({ ...prev, read: false }));
      },
      (error) => {
        setLoading((prev) => ({ ...prev, read: false }));
      },
    );
  };

  const createCommentTemplate = (params) => {
    setLoading((prev) => ({ ...prev, create: true }));
    axiosPost(
      URL.insertCommentBank,
      params,
      (response) => {
        if (response?.status === 200) {
          swal("Success", "Successfully created comment template");
          getCommentBank(true);
        }
        setLoading((prev) => ({ ...prev, create: false }));
      },
      (error) => {
        swal(
          "Oops",
          error?.response?.data?.message || "Failed to create comment template",
        );
        setLoading((prev) => ({ ...prev, create: false }));
      },
    );
  };

  const deleteCommentTemplate = (id) => {
    setLoading((prev) => ({ ...prev, delete: true }));
    axiosPost(
      URL.deleteCommentBank,
      { id: id },
      (response) => {
        if (response?.status === 200) {
          swal("Success", "Successfully deleted comment template");
          getCommentBank(true);
        }
        setLoading((prev) => ({ ...prev, delete: false }));
      },
      (error) => {
        swal(
          "Oops",
          error?.response?.data?.message || "Failed to delete comment template",
        );
        setLoading((prev) => ({ ...prev, delete: false }));
      },
    );
  };

  useEffect(() => {
    getCommentBank(true);
  }, []);

  return {
    loading,
    commentBank,
    getCommentBank,
    createCommentTemplate,
    deleteCommentTemplate,
  };
};

export const useResetGeneralAssessment = () => {
  const [loading, setLoading] = useState(false);

  const resetGeneralAssessment = (params) => {
    setLoading(true);
    new Promise((resolve, reject) => {
      axiosPost(
        URL.resetGeneralAssessment,
        params,
        (response) => {
          if (response?.status === 200) {
            swal("Success", "Successfully reset students record");
            resolve(response);
          } else {
            reject(response);
          }
          setLoading(false);
        },
        (error) => {
          swal(
            "Oops",
            error?.response?.data?.message || "Failed to reset students record",
          );
          setLoading(false);
          reject(error);
        },
      );
    });
  };

  return {
    loading,
    resetGeneralAssessment,
  };
};
